import { useEffect, useRef, type ReactNode } from 'react';
import type { RecordOpen } from '../tasks/model.ts';

export const OPENED_WORDS: Record<NonNullable<RecordOpen['opened_from']>, string> = {
  timeline: 'Opened from the Timeline', task: 'Opened from the task',
};

/**
 * Deploy 8 (A-#227): THE mark for a record opened at its own place (a commission's order, a filing's row, a site visit),
 * the same everywhere: a tinted block with a clear border, a small label saying where it was opened from, scrolled into
 * view and focused, so it cannot be missed. A list row (li); unopened, it is the plain row it always was.
 */
export function OpenedRecord({ opened, from, id, className = '', children }: {
  opened: boolean; from?: RecordOpen['opened_from'] | null; id?: string; className?: string; children: ReactNode;
}) {
  const ref = useRef<HTMLLIElement>(null);
  useEffect(() => {
    if (!opened || !ref.current) return;
    ref.current.scrollIntoView({ block: 'center' });
    ref.current.focus({ preventScroll: true });
  }, [opened]);
  return (
    <li ref={ref} id={id} tabIndex={opened ? -1 : undefined} aria-current={opened ? 'true' : undefined}
        data-opened={opened ? 'true' : undefined}
        className={opened ? `${className} -mx-2 rounded-lg border-2 border-accent bg-tint px-2 py-2` : className}>
      {opened && from && (
        <p className="w-full basis-full text-xs font-bold tracking-[0.08em] text-brand-text uppercase">{OPENED_WORDS[from]}</p>
      )}
      {children}
    </li>
  );
}
